import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.function.name";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import differenceInDays from 'date-fns/differenceInDays';
import classnames from 'classnames';
import StarRating from '@nerdwallet/react-star-rating';
import LikeIcon from '@nerdwallet/react-icon/gizmo/Like'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import find from 'lodash/find'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import capitalize from 'lodash/capitalize';
import LoginPopover from './login-popover';
import { DEFAULT_USER_IMAGE, DEFAULT_PROVIDERS } from './images';
import { ElementInteraction } from '../tracking';

function getDaysSinceDate(date) {
  return differenceInDays(new Date(), date);
}

var propTypes = {
  gigya: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    user: PropTypes.object
  }),
  comment: PropTypes.shape({
    timestamp: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    ratings: PropTypes.object,
    commentTitle: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    sender: PropTypes.object,
    commentText: PropTypes.string,
    vote: PropTypes.oneOf(['pos', 'neg', 'none']),
    TotalVotes: PropTypes.number,
    ID: PropTypes.string
  }),
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  streamID: PropTypes.string,
  voteComment: PropTypes.func,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementPosition: PropTypes.string
};
var defaultProps = {
  gigya: {},
  comment: {},
  voteComment: function voteComment() {}
};

var Comment =
/*#__PURE__*/
function (_Component) {
  _inherits(Comment, _Component);

  function Comment(props) {
    var _this;

    _classCallCheck(this, Comment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Comment).call(this, props));
    _this.voteComment = _this.voteComment.bind(_assertThisInitialized(_this));
    _this.handleVoteClick = _this.handleVoteClick.bind(_assertThisInitialized(_this));
    _this.getNewVoteValue = _this.getNewVoteValue.bind(_assertThisInitialized(_this));
    _this.hideLoginPopover = _this.hideLoginPopover.bind(_assertThisInitialized(_this));
    _this.handleLoginPopoverClick = _this.handleLoginPopoverClick.bind(_assertThisInitialized(_this));
    _this.state = {
      showLoginPopover: false
    };
    return _this;
  }

  _createClass(Comment, [{
    key: "getNewVoteValue",
    value: function getNewVoteValue() {
      // We only allow positive votes (or removal of a previous positive vote)
      // Therefore we will return a neutral vote if it's already positive.
      // And a positive vote for any other case.
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      return this.props.comment.vote === 'pos' ? 'none' : 'pos';
    }
  }, {
    key: "voteComment",
    value: function voteComment(provider) {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.voteComment({
        provider: provider,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        streamID: this.props.streamID,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        commentID: this.props.comment.ID,
        vote: this.getNewVoteValue()
      });
    }
  }, {
    key: "handleVoteClick",
    value: function handleVoteClick() {
      var gigya = this.props.gigya; // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration

      var isLoggedIn = gigya.auth.loginToken.get() !== null;

      if (!isLoggedIn) {
        this.setState({
          showLoginPopover: true
        });
      } else {
        this.voteComment();
      }
    }
  }, {
    key: "hideLoginPopover",
    value: function hideLoginPopover() {
      this.setState({
        showLoginPopover: false
      });
    }
  }, {
    key: "handleLoginPopoverClick",
    value: function handleLoginPopoverClick(provider) {
      // Pass login provider to use for login before posting comment
      this.voteComment(provider);
      this.hideLoginPopover();
    }
  }, {
    key: "renderLoginPopover",
    value: function renderLoginPopover() {
      return (// eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        this.state.showLoginPopover && React.createElement(ElementInteraction, {
          id: "nw-comment__login-popover",
          elementName: "nw-comment__login-popover",
          sectionCategory: "comment",
          elementCategory: "popover"
        }, React.createElement(LoginPopover, {
          onClick: this.handleLoginPopoverClick,
          onClose: this.hideLoginPopover
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          comment = _this$props.comment,
          gigya = _this$props.gigya;
      var days = getDaysSinceDate(comment.timestamp);
      var timeSincePosted = days === 1 ? '1 day ago' : "".concat(days, " days ago");
      var likeButtonClasses = classnames('nw-review-comment__like', {
        liked: comment.vote === 'pos' && gigya.user
      });
      var userImage = comment.sender.photoURL || DEFAULT_USER_IMAGE;
      var loginProviderIcon = (find(DEFAULT_PROVIDERS, {
        name: capitalize(comment.sender.loginProvider)
      }) || {}).icon;
      return React.createElement("article", {
        className: "nw-review-comment"
      }, React.createElement("header", null, React.createElement("section", {
        className: "nw-review-comment__title"
      }, React.createElement("div", {
        className: "nw-review-comment__rating"
      }, React.createElement(StarRating, {
        rating: get(comment, 'ratings._overall')
      })), React.createElement("div", {
        className: "nw-review-comment__summary"
      }, comment.commentTitle)), React.createElement("section", {
        className: "nw-review-comment__user"
      }, React.createElement("div", {
        className: "nw-review-comment__photo"
      }, React.createElement("img", {
        className: "nw-review-comment__image",
        alt: "user avatar",
        src: userImage
      }), loginProviderIcon && React.createElement("img", {
        className: "nw-review-comment__provider-logo",
        alt: "provider logo",
        src: loginProviderIcon
      })), React.createElement("div", {
        className: "nw-review-comment__time"
      }, timeSincePosted), React.createElement("div", {
        className: "nw-review-comment__username"
      }, comment.sender.name))), React.createElement("section", {
        className: "nw-review-comment__body"
      }, React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: comment.commentText
        }
      })), React.createElement("footer", {
        className: "nw-review-comment__footer"
      }, React.createElement("div", {
        className: "nw-review-comment__footer--left"
      }, React.createElement("ul", {
        className: "nw-review-comment__linksContainer"
      }, React.createElement(ElementInteraction, {
        type: "CLICK",
        id: "nw-review-comment__like",
        elementName: "nw-review-comment__like",
        sectionCategory: "comment",
        elementCategory: "button",
        elementDomType: "button" // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        elementPosition: this.props.elementPosition
      }, React.createElement("li", {
        className: likeButtonClasses,
        onClick: this.handleVoteClick
      }, React.createElement(LikeIcon, {
        className: "nw-review-comment__like__icon"
      }), React.createElement("div", {
        className: "nw-review-comment__like__count"
      }, comment.TotalVotes))), this.renderLoginPopover()))));
    }
  }]);

  return Comment;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


Comment.displayName = 'Comment'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

Comment.propTypes = propTypes; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

Comment.defaultProps = defaultProps;
export default Comment;